export const openResourceInNewTab = (resource: string, id?: string): void => {
  const basename = process.env.REACT_APP_INGORD_BASE_URL ?? process.env.PUBLIC_URL ?? '';
  const normalizedBasename = basename.endsWith('/') ? basename.slice(0, -1) : basename;
  const relativePath = id !== undefined ? `/${resource}/${id}` : `/${resource}`;
  const url = `${window.location.origin}${normalizedBasename}${relativePath}`;
  window.open(url, '_blank');
};
